<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <StaffNav/>
   <v-row>
     <v-col cols="12" lg="3" xl="2">
      <StaffSide/>
    </v-col>
    <v-col cols="12" lg="9" xl="10">
    <v-data-table
      :headers="headers"
      :items="reimbursements"
      sort-by="Date"
      sort-desc
      class="elevation-1"
      :loading="isLoading"
      loading-text="Loading Reimbursements"
      :search="search"
      height="550"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Reimbursements</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <report-list-actions
            :reportOptions="reportOptions"
            :downloadFilename="reportListFilename"
          ></report-list-actions>
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on }">
              <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Reimbursement</v-btn
              >
            </template>
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm  }}</span>
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  lazy-validation
                >
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                        <!-- <v-menu
                            offset-y
                            min-width="290px"
                            max-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="newDate"
                                    label="Date"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="newDate" scrollable></v-date-picker>
                        </v-menu> -->
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="newDate"
                              label="Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules='requiredField'
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="newAmount"
                        label="Amount"
                        prefix="$"
                        type="number"
                        :rules='requiredField'
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newType"
                        label="Type"
                        :items="type"
                        @change="updateCategory()"
                        :rules='requiredField'
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newCategory"
                        label="Category"
                        :items="category"
                        :rules='requiredField'
                      ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="newCategory == 'Other'">
                      <v-text-field
                        label="Other"
                        v-model="newOther"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Payee"
                        v-model="newPayee"
                        :rules='requiredField'
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="newBalance"
                        label="Balance"
                        readonly
                      ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="newDescription"
                        label="Description"
                        outlined
                        :rules='requiredField'
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-file-input   
                        v-model="newReceipt"                             
                        class="pa-2"
                        label="Receipt"
                        filled
                        multiple
                        prepend-icon="mdi-camera"
                        accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"
                        show-size
                        :rules='requiredField'
                      >
                        <template #selection="{ text, index }">
                          <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                        </template>
                      </v-file-input>
                      <!--
                      <v-file-input
                        chips
                        show-size                        
                        class="pa-2"
                        label="Receipt"
                        :placeholder="newReceipt"
                        filled
                        accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"
                      ></v-file-input>
                      -->
                      <!-- <v-img
                        max-height="280"
                        max-width="350"
                        :src="AWSLink"  
                      ></v-img> -->
                    </v-col>
                    <v-col cols="12"
                        v-for="doc in newReceipt"
                        :key="doc.id"
                      >
                        <div v-if="doc.ext !='pdf' ">
                          <v-img
                            max-height="480"
                            max-width="550"
                            :src="doc.aws"  
                          ></v-img>
                        </div>
                        <div v-if="doc.ext =='pdf' ">
                          <load-pdf 
                            :pdfFile="doc.aws"
                            :pdfName="doc.name"
                          />
                        </div>
                      </v-col>
                    <v-col cols="12" sm="12">
                      <v-checkbox
                        @click="addSignature()"
                        v-model="checkSignature"
                        label=" Staff Signature"
                        :rules='requiredField'
                      ></v-checkbox>
                      <v-expand-transition>
                        <v-text-field v-if="checkSignature" v-model="newSignature" readonly></v-text-field>
                      </v-expand-transition>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="status"
                        label="Payment status"
                        :items="statuses"
                        :rules='requiredField'
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        label="Payment notes"
                        v-model="newNote"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" v-if="status == 'Paid'">
                      <v-checkbox
                        @click="addManagerSignature()"
                        v-model="checkManagerSignature"
                        label=" Manager Signature"
                      ></v-checkbox>
                      <v-expand-transition>
                        <v-text-field v-if="checkManagerSignature" v-model="newManagerSignature" readonly></v-text-field>
                      </v-expand-transition>
                    </v-col>
                  </v-row>
                </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
              <v-btn
                  fab
                  small
                  @click="showPrintModal()"
                  class="mr-8 mb-2 white--text"
                  color="#2b6993"
                  elevation="4"
                  >
                  <v-icon>print</v-icon>
              </v-btn>
                <v-btn color="#259647" class="white--text" @click="addReimbursement()" v-if="newReimbursement && !isAuditorRole">Save</v-btn
                >
                <v-btn color="#259647" class="white--text" @click="updateReimbursement()" v-if="editReimbursement && !isAuditorRole">Update</v-btn
                >
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
      </template>

     <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="downloadDocument(item)">
          mdi-download
        </v-icon>
        <v-icon small class="mr-2" @click="viewReimbursement(item)">
          mdi-eye
        </v-icon>
        <!-- <v-icon small class="mr-2" @click="editCode(item)">
          mdi-pencil
        </v-icon> -->
        <v-icon v-if="!isAuditorRole" small @click="deleteReimbursement(item)">
          mdi-delete
        </v-icon>
        <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getReimbursements()">Reset</v-btn>
      </template>
    </v-data-table>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import StaffNav from '../components/StaffNav'
import StaffSide from '../components/StaffSide'
import Foot from '../components/Footer'
import moment from 'moment'
import LoadPdf from '@/components/LoadPDF.vue'
import renameFileHelper from '../mixins/renameFileHelper'
import ReportListActions from '../components/Report/ReportListActions.vue'
import PrintUtil from "../../utils/print-util";

const url = require("../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    StaffNav,
    StaffSide,
    Foot,
    LoadPdf,
    ReportListActions,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: false,
          value: 'Date',
        },
        { text: "Amount", value: "Amount" },
        { text: "Type", value: "Type" },
        { text: "Category", value: "Category" },
        // { text: "Balance", value: "Balance" },
        { text: "Entered By", value: "EnteredBy" },
        { text: "Status", value: "Status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      signed: false,
      managerSigned: false,
      dialog: false,
      checkSignature: false,
      checkManagerSignature: false,
      editReimbursement: false,
      newReimbursement: false,
      newSignature: "",
      newManagerSignature: "",
      staff: localStorage.getItem('Name'),
      msg: false,
      search: "",
      text:"",
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      reimbursements: [],
      tempData: [],
      employeeID: this.$route.params.employeeID,
      type: ["Cash", "Debit Card"],
      titleForm: "New Reimbursement",
      reimbursementID: "",
      newDate: "",
      newAmount: "",
      newType: "",
      newBalance: "",
      newDescription: "",
      newReceipt: [],
      newEnteredBy: "",
      newManager: "",
      newOther: "",
      newPayee: "",
      newCategory: "",
      status: "Outstanding",
      AWSLink: "",
      requiredField: [
          v => !!v || 'This is required',
      ],
      category: [
        "Client Purchase",
        "Mileage",
        "Reimbursement",
        "Other"
      ],
      editedIndex: -1,
      editedItem: {
        date: "",
        amount: "",
        type: "",
        balance: "",
        description: "",
        receipt: "",
        enteredBy: "",
        manager: "",
      },
      defaultItem: {
        date: "",
        amount: "",
        type: "",
        balance: "",
        description: "",
        receipt: "",
        enteredBy: "",
        manager: "",
      },
      isLoading: true,
      uploadFile: "",
      statuses: [
        'New',
        'Pending',
        'Paid',
        'Not paid'
      ],
      newNote: ''
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    staffName() {
      // `this` points to the component instance
      return this.$store.state.staff.staff.Name;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    selectedEmployee() {
      return this.$store.state.users.allUsers.find(
          (user) => user._id == this.employeeID  
      )
    },
    employeeName() {
      return this.selectedEmployee?.Name ?? this.staff
    },
    reportOptions() {
      return { 
        query: {
          name: this.employeeName,
        },
        endpoints: `reimbursements/printList/${this.employeeID}`,
        dynamic: true
      }
    },
    reportListFilename() {
      return `${this.employeeName} - Reimbursements`
    },
    generateDownloadUrl() {
      return `${url}/reimbursements/print-pdf?id=${this.reimbursementID}`;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getReimbursements();
  },

  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.reimbursementID, this.token, 'Reimbursement');
      });
  },

  beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.reimbursementID, this.token, 'Reimbursement');
      });
  },
  methods: {
    initialize() {
      this.reimbursements = [];
    },
    validate() {
        return this.$refs.form.validate();
    },
    viewReimbursement(item) {
      item.EnteredBy != '' ? this.checkSignature = true : this.checkSignature = false
      item.Manager != '' ? this.checkManagerSignature = true : this.checkManagerSignature = false
      this.titleForm= "Viewing Reimbursement"
      this.dialog = true;
      this.editReimbursement= true;
      this.newReimbursement = false;
      this.newDate= moment(item.Date).format("YYYY-MM-DD");
      this.newAmount= item.Amount;
      this.newType= item.Type;
      this.newCategory= item.Category;
      this.newOther= item.Other;
      this.newPayee= item.Payee;
      this.newBalance= item.Balance;
      this.newDescription= item.Description;
      this.status = item.Status;
      this.newNote = item.Note;
      
      //this.newReceipt= item.Receipt?.Name || '';
      if(item.documents.length > 0){
        const tempData = [];
        for(let i = 0; i < item.documents.length ; i++){
          let fileExt = item.documents[i].AWSLink.split('.').pop();
          tempData.push({
            name: item.documents[i].Name,
            id:  item.documents[i]._id,
            aws: item.documents[i].AWSLink,
            ext: fileExt
          });
        }
        this.newReceipt = tempData;
      }

      this.AWSLink = this.newReceipt[0]?.aws ?? "";
      this.newSignature = item.EnteredBy;
      this.newManagerSignature = item.Manager;
      this.reimbursementID= item._id;
      
    },
    showAdd() {
      this.titleForm= "New Reimbursement";
      this.newReimbursement = true;
      this.editReimbursement  = false;
    },

    deleteReimbursement(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this reimbursement?") &&
      this.reimbursementDelete(id);

    },

    reimbursementDelete(id) {
      axios.delete(`${url}/reimbursements/${id}`)
      .then((response) => {
        this.getReimbursements();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The reimbursement has been deleted successfully.";
      });
    },

    close() {
      this.clear();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateReimbursement() {
      const d = new Date(Date.now());
      const newDate = new Date(this.newDate);

      newDate.setHours(d.getHours())
      newDate.setMinutes(d.getMinutes())
      newDate.setSeconds(d.getSeconds())
      newDate.setMilliseconds(d.getMilliseconds())

      var req_body = {
        Date: newDate.toISOString(),
        Amount: this.newAmount,
        Type: this.newType,
        Category: this.newCategory,
        Other: this.newOther,
        Payee: this.newPayee,
        Balance: this.newBalance,
        Description: this.newDescription,
        // Receipt: this.newReceipt,
        EnteredBy: this.newSignature,
        Manager: this.newManagerSignature,
        Status: this.status,
        Note: this.newNote

      };
      axios.put(`${url}/reimbursements/${this.reimbursementID}`, req_body).then((response) => {
        this.getReimbursements();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg =true;
        this.text ="The reimbursement has been updated successfully.";
      
        this.saveFile();
      
      });
      this.close();
    },
    getReimbursements: function() {
      this.isLoading = true;
      axios.get(`${url}/reimbursements/staff/${this.employeeID}`).then(res => {
        this.reimbursements = res.data.reimbursements;
        for(var i=0;i<this.reimbursements.length;i++){
          var dt = new Date(this.reimbursements[i].Date);
          this.reimbursements[i].Date = moment(dt).format("YYYY-MM-DD");
        }
      }).finally(() => this.isLoading = false);
    },

    addReimbursement: function() {
      if(this.validate()){
        const d = new Date(Date.now());
        const newDate = new Date(this.newDate);

        newDate.setHours(d.getHours())
        newDate.setMinutes(d.getMinutes())
        newDate.setSeconds(d.getSeconds())
        newDate.setMilliseconds(d.getMilliseconds())

        var req_body = {
          Date: newDate.toISOString(),
          Amount: this.newAmount,
          Type: this.newType,
          Category: this.newCategory,
          Other: this.newOther,
          Payee: this.newPayee,
          Balance: this.newBalance,
          Description: this.newDescription,
          Receipt: this.newReceipt,
          EnteredBy: this.newSignature,
          Manager: this.newManagerSignature,
          Status: this.status,
          EmployeeID: this.employeeID,
          Note: this.newNote
        };

        axios.post(`${url}/reimbursements`, req_body ).then(res => {
          this.getReimbursements();
          if (res.status == 400) {
            res.json().then(function(data) {
              this.text=data.msg;
            });
          }
          this.msg =true;
          this.text ="The new reimbursement has been added successfully.";
          this.reimbursementID = res.data._id
          this.saveFile();
        });
        this.close();
      }
      this.msg = true;
      this.text="Please fill out all required fields"
    },
    addSignature: function() {
      if (this.checkSignature == false) {
        this.newSignature = "";
        this.signed = false;
      }

      if (this.signed === false) {
        // this.newSignature = this.staff + " - " + new Date();
        if (this.signed == false) this.timeSigned();
        this.signed = true;
      }
    },
    addManagerSignature: function() { 
      if (this.checkManagerSignature === false) {
        this.newManagerSignature = "";
        this.managerSigned = false;
      }
      if(this.managerSigned === false){
        // this.newManagerSignature = this.staff + " - " + new Date();
        if (this.managerSigned == false) this.timeSigned();
        this.managerSigned = true;
      }
    },

    timeSigned() {
      setTimeout(() => {
        const today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth();
        let date = today.getDate();

        let h = today.getHours();
        let m = today.getMinutes();
        let s = today.getSeconds();

        if (this.checkSignature) this.newSignature = this.staff + " - " + new Date(year, month, date, h, m, s);
        if (this.checkManagerSignature) this.newManagerSignature = this.staff + " - " + new Date(year, month, date, h, m, s);
        
        if (this.signed || this.managerSigned) this.timeSigned();
      }, 1000);
    },

    downloadDocument(item){
      if(item.documents === undefined){
          this.msg=true;
          this.text ="No document found";
      }else{
        for(let i = 0; i < item.documents.length ; i++){
          let docURL = item.documents[i].AWSLink;
          var FileSaver = require('file-saver');
          FileSaver.saveAs(docURL, item.documents[i].Name);
        }
      }
    },

    clear(){
      this.newDate= "";
      this.newAmount = "";
      this.newType = "";
      this.newCategory = "";
      this.newOther = "";
      this.newPayee = "";
      this.newBalance = "";
      this.newDescription = "";
      this.newReceipt = [];
      this.newSignature = "";
      this.newManagerSignature = "";
      this.status = "";
      this.checkSignature = false;
      this.checkManagerSignature = false;
      this.signed = false;
      this.managerSigned = false;
    },

    async fileSelected(e) {
      this.uploadFile= await this.renameFileHelper(e, this.staffName, this.newPayee, this.newDate);
    },

    saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        this.uploadFiles(this.uploadFile[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append('reimbursement', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/reimbursements/fileuploader/${this.reimbursementID}/${this.employeeID}`,formData, ct)
      .then(res => {
        if(res){
          this.getReimbursements();
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newAdjustmentDocument.splice(index, 1);
    },

    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.reimbursementID, this.token,'Reimbursement');
    },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>